/**
 * Sample values
 * window.base_domain = '.aperza.jp';
 window.tokenKey = 'atkn';
 window.base_cluez_member_domain = 'member.cluez.biz';
 window.cdn_base_domain = '//static.aperza.jp';
 window.env_locale_balloon = null;
 */
export default class AppConfig {

  static APERZA_SEARCH = 'search-aperza';
  static APERZA_EC = 'aperza-ec';
  static APERZA_CATALOG = 'catalog';
  static APERZA_NEWS = 'news-aperza';
  static APERZA_ID = 'id-aperza';
  static APERZA_ACCOUNT = 'account-aperza';
  static APERZA_ORDER = 'aperza-order';
  static APERZA_BIZ = 'aperza-biz';

  static ENV_PROD = '';
  static ENV_STG = 'stg';
  static ENV_TEST = 'test';
  static ENV_LOCAL = 'local';

  static API_HOST_PROD = 'https://api.aperza.com';
  static API_HOST_STG = 'https://api.stg.aperza.com';
  static API_HOST_TEST = 'https://api.test.aperza.com';
  static API_HOST_LOCAL = 'http://localhost:8081';

  _serviceType;
  _env;

  /**
   * Aperza Catalog is sharing the same domain as search-web
   * thus need another flag to idenfity aperza catalog as
   * some parts on the header must be hidden for aperza catalog.
   */
  _isAperzaCatalog;

  /**
   * If the current page is the Aperza Catalog Top Page
   */
  _isAperzaCatalogTop;

  _isAperzaMarketplace;

  _isAperzaSearchItemResultPage;
  _isAperzaSearchCatalogResultPage;

  _isAperzaIdDomain;

  _isAperzaAccountDomain;

  _isAperzaOrderDomain;
  _isOrderCheckout;
  _isAperzaBusinessDomain;

  /**
   * To link to other Aperza Services
   * Example: _baseDomain = "test.aperza.jp"
   * Related Sites:
   * search-web: www.test.aperza.jp
   * id: id.test.aperza.jp
   */
  _baseDomain;

  /**
   * Related .com domain of the site
   * e.g. '.test.aperza.jp' and '.test.aperza.com'
   */
  _baseComDomain;

  /**
   * cookie name which stores the authentication token
   */
  _tokenKey;

  /**
   * cookie name which stores the user's locale/language code
   */
  _langKey;

  /**
   * user's locale/language code
   */
  _langCode;

  _baseCluezMemberDomain;

  /**
   * Cloudfront Host
   */
  _cdnHost;

  /**
   * To indicate with environment
   * test, stg or prod.
   * For prod, this will be initialized to null.
   */
  _envLocaleBalloon;

  _searchWebHost;
  _accountWebHost;
  _marketplaceWebHost;
  _mainPage;
  _aperzaIdHost;
  _aperzaAccountHost;

  _automationNewsUrl;

  _hideProductCategory;

  /**
   * include lang code
   */
  get searchWebUrlPrefix() {
    return `${this.searchWebHost}${this.langCode=='en'?'/'+this.langCode:''}`;
  }

  /**
   * include lang code
   */
  get marketplaceWebUrlPrefix() {
    return `${this.marketplaceWebHost}${this.langCode=='en'?'/'+this.langCode:''}`;
  }

  get serviceType() {
    return this._serviceType;
  }

  set serviceType(value) {
    this._serviceType = value;
  }

  get env() {
    return this._env;
  }

  set env(value) {
    this._env = value;
  }

  get isAperzaCatalog() {
    return this._isAperzaCatalog;
  }

  set isAperzaCatalog(value) {
    this._isAperzaCatalog = value;
  }

  get isAperzaCatalogTop() {
    return this._isAperzaCatalogTop;
  }

  set isAperzaCatalogTop(value) {
    this._isAperzaCatalogTop = value;
  }

  get isAperzaMarketplace() {
    return this._isAperzaMarketplace;
  }

  set isAperzaMarketplace(value) {
    this._isAperzaMarketplace = value;
  }

  get isAperzaSearchItemResultPage() {
    return this._isAperzaSearchItemResultPage;
  }

  set isAperzaSearchItemResultPage(value) {
    this._isAperzaSearchItemResultPage = value;
  }

  get isAperzaSearchCatalogResultPage() {
    return this._isAperzaSearchCatalogResultPage;
  }

  set isAperzaSearchCatalogResultPage(value) {
    this._isAperzaSearchCatalogResultPage = value;
  }

  get isAperzaIdDomain() {
    return this._isAperzaIdDomain;
  }

  set isAperzaIdDomain(value) {
    this._isAperzaIdDomain = value;
  }

  get isAperzaAccountDomain() {
    return this._isAperzaAccountDomain;
  }

  set isAperzaAccountDomain(value) {
    this._isAperzaAccountDomain = value;
  }

  get isAperzaOrderDomain() {
    return this._isAperzaOrderDomain;
  }

  set isAperzaOrderDomain(value) {
    this._isAperzaOrderDomain = value;
  }

  get isOrderCheckout() {
    return this._isOrderCheckout;
  }

  set isOrderCheckout(value) {
    this._isOrderCheckout = value;
  }

  get isAperzaBusinessDomain() {
    return this._isAperzaBusinessDomain;
  }

  set isAperzaBusinessDomain(value) {
    this._isAperzaBusinessDomain = value;
  }

  get baseDomain() {
    return this._baseDomain;
  }

  set baseDomain(value) {
    this._baseDomain = value;
  }

  get baseComDomain() {
    return this._baseComDomain;
  }

  set baseComDomain(value) {
    this._baseComDomain = value;
  }

  get tokenKey() {
    return this._tokenKey;
  }

  set tokenKey(value) {
    this._tokenKey = value;
  }

  get langKey() {
    return this._langKey;
  }

  set langKey(value) {
    this._langKey = value;
  }

  get langCode() {
    return this._langCode;
  }

  set langCode(value) {
    this._langCode = value;
  }

  get baseCluezMemberDomain() {
    return this._baseCluezMemberDomain;
  }

  set baseCluezMemberDomain(value) {
    this._baseCluezMemberDomain = value;
  }

  get cdnHost() {
    return this._cdnHost;
  }

  set cdnHost(value) {
    this._cdnHost = value;
  }

  get envLocaleBalloon() {
    return this._envLocaleBalloon;
  }

  set envLocaleBalloon(value) {
    this._envLocaleBalloon = value;
  }

  get searchWebHost() {
    return this._searchWebHost;
  }

  set searchWebHost(value) {
    this._searchWebHost = value;
  }

  get accountWebHost() {
    return this._accountWebHost;
  }

  set accountWebHost(value) {
    this._accountWebHost = value;
  }

  get marketplaceWebHost() {
    return this._marketplaceWebHost;
  }

  set marketplaceWebHost(value) {
    this._marketplaceWebHost = value;
  }

  get mainPage() {
    return this._mainPage;
  }

  set mainPage(value) {
    this._mainPage = value;
  }

  get automationNewsUrl() {
    return this._automationNewsUrl;
  }

  get aperzaIdHost() {
    return this._aperzaIdHost;
  }

  set aperzaIdHost(value) {
    this._aperzaIdHost = value;
  }

  get aperzaAccountHost() {
    return this._aperzaAccountHost;
  }

  set aperzaAccountHost(value) {
    this._aperzaAccountHost = value;
  }

  set automationNewsUrl(value) {
    this._automationNewsUrl = value;
  }

  get hideProductCategory() {
    return this._hideProductCategory;
  }

  set hideProductCategory(value) {
    this._hideProductCategory = value;
  }
}

